//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'

export default {
	name: 'HomeComponent',
	props: {
		user: { type: Object, required: true }
	},
	data () {
		return {
			service: null,
			employee: null,
			employees: [],
			schedule: [],
			events: [],
			countries: [],
			time: null,
			client: {
				first_name: '',
				last_name: '',
				email: '',
				dob: {
					date: '',
					max: new Date().toISOString().substring(0, 10),
					min: '1950-01-01',
					view: null,
					calendar: false
				},
				country: '',
				mobile: '',
			},
			picker: {
				date: '',
				min: moment().format('Y-MM-DD')
			},
			alert: {
				isOpened: false,
				message: '',
				icon: '',
				color: '',
				errors: {},
			},
			v: new Object(),
			disabled: false
		}
	},
	computed: {
		computedDob () {
			return this.formatDate(this.client.dob.date)
		}
	},
	watch: {
		service () {
			// this.setEmployees()
			if (this.service) {
				this.checkAvailability()
			}
		},
		employee () {
			if (this.employee) {
				this.checkAvailability()
			}
		},
		'picker.date' () {
			if (!this.service) { return false }
			this.checkAvailability()
		},
		'client.dob.calendar' (calendar) {
			calendar && setTimeout(() => (this.client.dob.view = 'YEAR'))
		},
	},
	methods: {
		formatDate (date) {
			if (!date) return null
			const [year, month, day] = date.split('-')
			return `${day}/${month}/${year}`
		},
		setDob (date) {
			this.$refs['dob-menu'].save(date)
		},
		setEmployees () {
			this.employees = []
			this.schedule = []
			this.employee = null
			this.time = null
			if (_.isEmpty(this.service)) { return false }
			this.service.categories.forEach(category => {
				let employees = this.user.employees.filter(employee => employee.categories.some(cat => cat.id === category.id))
				this.employees = _.union(employees, this.employees)
			})
		},
		checkAvailability () {
			axios.get(`/scheduler/${this.user.id}`, {
				params: {
					service_id: this.service.id,
					// employee_id: this.employee.id,
					date: this.picker.date
				}
			}).then(response => {
				this.schedule = response.data.hours
			}).catch(error => {
				this.schedule = []
				console.error(error)
			})
		},
		addEvent () {
			const exists = this.events.find(event =>
				event.date == this.picker.date &&
				event.time == this.time)

			if (exists) { return false }

			this.events.unshift({
				service: this.service,
				date: this.picker.date,
				time: this.time
			})
			this.clearForm()
		},
		removeEvent (index) {
			this.events.splice(index, 1)
		},
		clearForm () {
			this.employee = null
			this.service = null
			this.picker.date = ''
			this.time = null
			this.schedule = []
		},
		loadCountries () {
			axios.get(`/v1/countries/`).then(response => {
				this.countries = response.data.countries
			}).catch(error => {
				console.error(error)
			})
		},
		storeAppointment () {
			this.resetErrorBag()
			this.disabled = true
			axios.post(`/appointment`, {
				user_id: this.user.id,
				events: this.events,
				client: this.client
			}).then(response => {
				this.resetForm()
				this.showAlert(response.data.message, 'fal fa-check', 'primary')
			}).catch(error => {
				this.v = new Object()
				setTimeout(() => { this.v = error.response.data.errors }, 50)
				this.showAlert(error.response.data.message, 'fal fa-exclamation-triangle', 'error', error.response.data.errors)
			}).then(() => {
				this.disabled = false
			})
		},
		resetErrorBag () {
			this.alert.isOpened = false
			this.alert.errors = {}
		},
		showAlert (message, icon, color, errors = {}) {
			this.submitting = false
			setTimeout(() => {
				this.alert =  {
					isOpened: true,
					message,
					icon,
					color,
					errors,
				}
			}, 50)
		},
		resetForm () {
			let countries = this.countries
			Object.assign(this.$data, this.$options.data.call(this))
			this.client.dob = {
				date: '',
				max: new Date().toISOString().substring(0, 10),
				min: '1950-01-01',
				view: null,
				calendar: false
			}
			this.countries = countries
		}
	},
	mounted () {
		this.loadCountries()
	}
}
